export const SkillsData = [
  {
    type: "Front-End",
    list: [
      {
        name: "ReactJS, React Native",
        icon: <i class="devicon-react-original colored"></i>
      },
      {
        name: "Nextjs",
        icon: <i class="devicon-nextjs-plain colored"></i>
        },
      {
        name: "JavaScript",
        icon: <i class="devicon-javascript-plain colored"></i>
      },
      {
        name: "TailwindCSS",
        icon: <i class="devicon-tailwindcss-plain colored"></i>
      },
    ],
  },
  {
    type: "Other Skills",
    list: [
      {
        name: "Laravel",
        icon: <i class="devicon-laravel-plain colored"></i>
      },
      {
        name: "Android",
        icon: <i class="devicon-android-plain colored"></i>
      },
      {
        name: "Firebase",
        icon: <i class="devicon-firebase-plain colored"></i>
      },
      {
        name: "ESLint",
        icon: <i class="devicon-eslint-plain colored"></i>
      },
      {
        name: "Kotlin",
        icon: <i class="devicon-kotlin-plain colored"></i>
      },
    ],
  },
];